import { Filter } from "@/lib/filterable";
import { IReport } from "./report.entity";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";
import { DamageTypeEnum } from "@/store/enum/damage-type.enum";
import { MrfiktivUpdateReportDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { DamageAreaEnum } from "@/store/enum/damage-area.enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";

class DamageBase
  implements
    Pick<
      MrfiktivUpdateReportDtoGen,
      "title" | "message" | "damageType" | "coverageType" | "isDrivable" | "isRoadworthy" | "totalLoss"
    > {
  _report?: Partial<IReport> | null = null;

  damageType?: DamageTypeEnum | null = null;
  coverageType?: CoverageTypeEnum | null = null;
  title?: string | null = null;
  message?: string | null = null;
  isDrivable?: boolean | null = null;
  isRoadworthy?: boolean | null = null;
  isWrapped?: boolean;
  isWrapDamaged?: boolean;

  totalLoss: TotalLossType | null = null;

  area?: DamageAreaEnum[] = [];

  /**
   *
   * @param obj
   */
  constructor(obj?: Partial<IReport>) {
    this._report = obj;
    this.damageType = obj?.damageType;
    this.coverageType = obj?.coverageType;
    this.isDrivable = obj?.isDrivable;
    this.isRoadworthy = obj?.isRoadworthy;
    this.message = obj?.message;
    this.title = obj?.title;
    this.area = obj?.damage;
    this.isWrapped = obj?.isWrapped;
    this.isWrapDamaged = obj?.isWrapDamaged;
    this.totalLoss = obj?.totalLoss as TotalLossType;
  }

  get dto(): Pick<
    MrfiktivUpdateReportDtoGen,
    | "title"
    | "message"
    | "damageType"
    | "coverageType"
    | "isDrivable"
    | "isRoadworthy"
    | "damage"
    | "isWrapDamaged"
    | "isWrapped"
    | "totalLoss"
  > {
    return {
      damageType: this.damageType,
      coverageType: this.coverageType,
      title: this.title,
      message: this.message,
      isDrivable: this.isDrivable,
      isRoadworthy: this.isRoadworthy,
      damage: this.area,
      isWrapDamaged: this.isWrapDamaged,
      isWrapped: this.isWrapped,
      totalLoss: this.totalLoss
    };
  }
}

type IDamage = DamageBase;
const Damage = Filter.createForClass(DamageBase);

export { Damage, IDamage };
